import React, { useEffect, useState } from 'react'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { Typography } from '@material-ui/core';
import ReactExport from 'react-data-export';
import { format } from 'date-fns';
import api from '../api';
import Loader from 'react-loader-spinner'

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export default function DownloadScheduleDokter(props) {
    const [tglMulai, setTglMulai] = useState(null)
    const [tglSelesai, setTglSelesai] = useState(null)
    const [download, setDownload] = useState(false)
    const [multiDataSet, setMultiDataSet] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getData()
    }, [tglMulai, tglSelesai])

    const getData = () => {
        let param = `date_filter={"schedule_date": {"start": "${format(new Date(tglMulai), 'yyyy-MM-dd')}", "end": "${format(new Date(tglSelesai), 'yyyy-MM-dd')}"}}`
        if (tglMulai && tglSelesai) {
            console.log(tglMulai, tglSelesai);
            setLoading(true)
            let judul = [
                { title: `Data ini di unduh pada ${format(new Date(), 'dd MMM yyyy, HH:mm:ss')}` }
            ]
            let subJudul = [
                [{ value: `filter by Nama user : ${props.nama}, Tanggal Mulai ${format(new Date(tglMulai), 'dd MM yyyy')}, Tanggal Akhir ${format(new Date(tglSelesai), 'dd MM yyyy')}` }]
            ]
            let data = []
            let column = [
                { title: "Clinic Name", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Doctor Name", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Service Type", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Time Type", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Quota", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "BPJS Quota", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Schedule Date", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Time Start", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Time End", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Room Name", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Time Slot", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Session Status", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Cancel/Leave/Holiday Notes", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Created At", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Updated At", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Deleted At", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Late Duration", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Hold Reason", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Created By Name", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Updated By Name", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Deleted By Name", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Public Notes", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Stop Reservation", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Leave Status", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Internal Notes", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
                { title: "Holiday Status", style: { fill: { patternType: "solid", fgColor: { rgb: "ACADAC" } }, font: { bold: true } }, },
            ]
            api.create().downloadScheduleDokter(param).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        if (response.data.data.length > 0) {
                            response.data.data.map((item) => {
                                if (item.polyclinic.length > 0) {
                                    item.polyclinic.map((items) => {
                                        if (items.schedule.length > 0) {
                                            items.schedule.map((itemss) => {
                                                data.push([
                                                    { value: items.polyclinic_name },
                                                    { value: item.name },
                                                    { value: itemss.service_type },
                                                    { value: itemss.time_type },
                                                    { value: itemss.quota },
                                                    { value: itemss.quota_bpjs === null ? 0 : itemss.quota_bpjs },
                                                    { value: itemss.date },
                                                    { value: itemss.time_start },
                                                    { value: itemss.time_end },
                                                    { value: itemss.room },
                                                    { value: itemss.time },
                                                    { value: "-" },
                                                    { value: itemss.notes === null ? "" : itemss.notes },
                                                    { value: itemss.created_at },
                                                    { value: itemss.updated_at === null ? '' : itemss.updated_at },
                                                    { value: itemss.deleted_at === null ? '' : itemss.deleted_at },
                                                    { value: "-" },
                                                    { value: "-" },
                                                    { value: itemss.created_by },
                                                    { value: itemss.updated_by === null ? '' : itemss.updated_by },
                                                    { value: itemss.deleted_by === null ? '' : itemss.deleted_by },
                                                    { value: itemss.remarks === null ? '' : itemss.remarks },
                                                    { value: itemss.is_stop },
                                                    { value: itemss.is_leave },
                                                    { value: itemss.internal_notes === null ? '' : itemss.internal_notes },
                                                    { value: itemss.is_holiday },
                                                ])
                                            })
                                        }
                                    })
                                }
                            })
                            setDownload(true)
                            let dataJadi = [
                                {
                                    columns: judul,
                                    data: subJudul
                                },
                                {
                                    columns: column,
                                    data: data
                                }
                            ]
                            setMultiDataSet(dataJadi)
                            setLoading(false)
                        }
                    }
                }
            })
        }
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{ height: props.height - 100, width: '100%', position: 'relative', padding: '20px 0' }}>
            {loading ? loadingComponent : null}
            <div>

                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        margin="normal"
                        id="tanggal"
                        label="Tanggal Mulai"
                        required={true}
                        format="dd/MM/yyyy"
                        value={tglMulai}
                        maxDate={tglSelesai ? tglSelesai : new Date()}
                        onChange={(date) => {
                            setTglMulai(date)
                        }}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        style={{ width: '30%', margin: 0 }}
                    />
                </MuiPickersUtilsProvider>
            </div>
            <div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        margin="normal"
                        id="tanggal"
                        label="Tanggal Selesai"
                        required={true}
                        format="dd/MM/yyyy"
                        value={tglSelesai}
                        minDate={tglMulai && tglMulai}
                        maxDate={new Date()}
                        onChange={(date) => {
                            setTglSelesai(date)
                        }}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        style={{ width: '30%', margin: '20px 0 0' }}
                    />
                </MuiPickersUtilsProvider>
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', position: 'absolute', bottom: 0, right: 0 }}>
                {download && (
                    <ExcelFile
                        element={
                            <div
                                style={{ backgroundColor: '#2a9c6c', width: 120, borderRadius: 20, padding: 5, display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
                                onClick={() => {
                                }}>
                                <Typography style={{ color: 'white' }}>Download</Typography>
                            </div>
                        }
                        filename={`Report Jadwal Dokter ${format(new Date(tglMulai), 'dd-MM-yyyy')} - ${format(new Date(tglSelesai), 'dd-MM-yyyy')}`}
                    >
                        <ExcelSheet dataSet={multiDataSet} name="Sheet" />
                    </ExcelFile>
                )}

            </div>

        </div>
    )
}
